import { theme as antdTheme, ThemeConfig } from 'antd';

// --- Typography & Sizing ---
const FONT_FAMILY_MAIN = "'Roboto', sans-serif";
const FONT_SIZE_BASE = 14; // Base font size for general text
const BORDER_RADIUS_BASE = 8;

export const legacyTheme: Partial<ThemeConfig> = {
  token: {
    colorPrimary: '#55C2EF',
    colorInfo: '#55C2EF',
    colorFillSecondary: '#e4eef5',
    colorError: '#BC5656',
    colorSuccess: '#34BC74',
    colorWarning: '#E4801E',
  },
}

export const darkTheme: Partial<ThemeConfig> = {
  algorithm: [antdTheme.darkAlgorithm],
  token: {
    colorPrimary: '#1668dc',
    colorInfo: '#2f83dc',
    colorError: '#dc4446',
    colorTextBase: '#fff',
  },
}

export const lightTheme: ThemeConfig = {
  cssVar: { prefix: 'bc', key: 'light-theme' },

  token: {
    // Primary & Info (different blues)
    colorPrimary: '#0092FF',
    colorInfo: '#3496FF',

    // Error (orange-red per design spec)
    colorError: '#F36B10',
    // Success & Warning: use antd default algorithms (green/gold presets per design spec)

    // Brand-blue text base — drives all text, fill, and spotlight tokens
    colorTextBase: '#17191A',
    colorTextPlaceholder: '#6F8CAE',
    colorBorder: '#E4EEF5',

    // Typography
    fontFamily: FONT_FAMILY_MAIN,
    fontSize: FONT_SIZE_BASE,

    // Sizing & Radius
    borderRadius: BORDER_RADIUS_BASE,
  },

  components: {
    Checkbox: {
      controlInteractiveSize: 18,
    },
    Button: {
      paddingInlineLG: 28,
    },
    Input: {
      fontSizeLG: 14,
    },
    Select: {
      optionPadding: '9px 12px',
      fontSize: 12,
      fontSizeLG: 14,
      optionFontSize: 14,
      multipleItemBg: 'none',
    },
    TreeSelect: {
      titleHeight: 32,
    },
    Steps: {
      navArrowColor: 'transparent',
    },
    Table: {
      headerBg: 'var(--bc-color-bg-container)',
      headerColor: '#6F8CAE',
      headerSplitColor: '#dde9f1',
    },
  },
};

export function createBrandTheme(
  overrides?: Partial<ThemeConfig>,
  cssVarKey: string = lightTheme.cssVar!.key!
): ThemeConfig {
  if (!overrides) {
    return {
      ...lightTheme,
      cssVar: { ...lightTheme.cssVar, key: cssVarKey }
    };
  }

  return {
    ...lightTheme,
    ...overrides,
    cssVar: {
      ...lightTheme.cssVar,
      ...(overrides.cssVar || {}),
      key: cssVarKey,
    },
    token: {
      ...lightTheme.token,
      ...overrides.token
    },
    components: {
      ...lightTheme.components,
      ...overrides.components,
    },
  };
}

